


















































































import { computed, defineComponent, reactive, ref } from "@vue/composition-api";
import { getLicences, Licence, updateLicences } from "@/data/repos/licences";
import { displayRequestStatus } from "@/notifications";
import { Button, SortableTable } from "@micad/vue-components/src/main";
import Loading from "@/components/Loading.vue";
import { canIUse } from "@/modules/auth";
const licencesColumns = [
  {
    name: "app",
    label: "Application",
    align: "left",
    field: (row: Licence) => row.app,
    classes: "primary",
    sortable: true,
  },
  {
    name: "concurrentUsers",
    label: "Concurrent users",
    align: "left",
    field: (row: Licence) =>
      row.concurrentUsers === 2147483647 ? "unlimited" : row.concurrentUsers,
    sortable: true,
  },
  {
    name: "expiresAt",
    label: "Expires at",
    align: "left",
    field: (row: Licence) =>
      new Date(row.expiresAt) < new Date()
        ? row.expiresAt + " (expired)"
        : row.expiresAt,
    sortable: true,
  },
  {
    name: "applications",
    label: "Issued at",
    align: "left",
    field: (row: Licence) => row.issuedAt,
    sortable: true,
  },
];

export default defineComponent({
  methods: { canIUse },
  components: {
    SortableTable,
    Button,
    Loading,
  },
  setup() {
    const licences: Licence[] = [];
    const showUpdateLicencesDialog = ref(false);
    const state = reactive({
      showUpdateLicencesDialog,
      saveLicences,
      toggleEditLicences: () =>
        (showUpdateLicencesDialog.value = !showUpdateLicencesDialog.value),
      max: 1,
      licencesColumns,
      licences: licences,
      loaded: false,
      licenceLines: [] as string[],
      licencesText: computed({
        get(): string {
          return (state.licenceLines as string[]).join("\n");
        },
        set(v: string) {
          state.licenceLines = v.split("\n");
        },
      }),
    });
    async function saveLicences() {
      const resp = await updateLicences(
        state.licenceLines.filter((line) => line)
      );
      displayRequestStatus(
        resp,
        "Licences were updated successfully",
        "Failed to update licences"
      );
      if (resp.ok) {
        state.toggleEditLicences();
        refreshLicences();
      }
    }
    function refreshLicences() {
      state.loaded = false;
      setTimeout(async () => {
        const resp = await getLicences();
        displayRequestStatus(resp, "", "Failed to load licences");
        if (resp.ok) {
          state.licences = (resp.payload && resp.payload.licences) || [];
          state.licenceLines =
            (resp.payload && resp.payload.licenceLines) || [];
        }
        state.loaded = true;
      });
    }
    refreshLicences();
    return state;
  },
});
